import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import QzTrayConnectionMonitor from "../../components/qztray/connectionMonitor/QzTrayConnectionMonitor";

/**
 * 🖧 Página: Estado de Conexión QZ Tray
 */
const QzTrayConnectionStatus = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <QzTrayConnectionMonitor />
    </DefaultLayout>
  );
};

export default QzTrayConnectionStatus;
